<template>
  <el-result title="404" subTitle="对不起，您访问的页面不存在。">
    <template slot="icon">
      <img src="/404.png" alt="" />
    </template>
    <template slot="extra">
      <el-button type="primary" size="medium" @click="toHome"> 返回首页 </el-button>
    </template>
  </el-result>
</template>

<script>

export default {
  name: 'Page404',
  computed: {
    message() {
      return '这个网页不存在'
    }
  },
  methods: {
    toHome () {
      this.$router.push({ path: '/' })
    }
  }
}
</script>

<style scoped>
img {
  width: 80%;
  height: 70%;
  margin: 10% auto 0 auto;
}

</style>
